// @ts-ignore
import i18n from "@/libs/i18n";
// @ts-ignore
import { formatDate } from "@/utils/luxon";
import { EventActor, EventEntryDto, EventPayloadType } from "@saysimple-platform/dtos";
import lodash from "lodash";

export const resolveEventEntryPayload = (eventEntry: EventEntryDto) => {
    return i18n.t(getEvent(eventEntry).text, {
        actor: getEvent(eventEntry).actor,
        target: getEvent(eventEntry).target,
        date: formatDate(eventEntry.time, {
            month: "numeric",
            day: "numeric",
            year: "numeric",
        }),
        time: formatDate(eventEntry.time, {
            hour: "2-digit",
            minute: "2-digit",
        }),
    });
};

const getActor = (eventEntry: EventEntryDto): EventActor => eventEntry.actor;
const getPayload = (eventEntry: EventEntryDto): EventPayloadType => eventEntry.payload;
const getEvent = (eventEntry: EventEntryDto) => {
    const actor = getActor(eventEntry);
    const payload = getPayload(eventEntry);
    let actorName = actor.actorFullName;

    switch (eventEntry.name) {
        case "chat::assigned":
            return {
                actor: actor.actorFullName,
                text: `${actor.actorFullName ? "has-" : ""}assigned-conversation-to`,
                target: payload.extra ? payload.extra.assignedName : "",
            };
        case "chat::unassigned":
            return {
                actor: actor.actorFullName,
                text: `${actor.actorFullName ? "has-" : ""}unassigned-conversation`,
            };
        case "chat::archive":
        case "chat::archived":
            return {
                actor: actor.actorFullName,
                text: `${actor.actorFullName ? "has-" : ""}archived-conversation-on`,
            };
        case "chat::unarchived":
            return {
                actor: actor.actorFullName,
                text: `${actor.actorFullName ? "has-" : ""}unarchived-conversation-on`,
            };
        case "chat::routed":
            return {
                actor: actor.actorFullName,
                text: "conversation-was-auto-assigned",
            };
        case "chat::started":
            if (actor.entityType === "system") {
                actorName = i18n.t("start-conversation.system");
            } else if (!actorName) {
                actorName = lodash.capitalize(i18n.t("someone"));
            }
            return {
                actor: actorName,
                text: "conversation-started",
            };
        default:
            return {
                text: "unknown-event",
            };
    }
};
